import React, {useEffect, useState, useRef} from "react";
import axios from "axios";
import $ from "jquery";
import DataTable from "datatables.net";
import {Link} from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import {useHistory} from 'react-router';
import {toAbsoluteUrl} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import alertify from "alertifyjs";
import {date_format, datetime_format} from "../Common/DateFormat";
import {API_URL, BACKEND_URL} from '../constants.js';
import PrintIcon from '@material-ui/icons/Print';
import DescriptionIcon from '@material-ui/icons/Description';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import EditIcon from '@material-ui/icons/Edit';
import BeachAccessIcon from '@material-ui/icons/BeachAccess';
import Form from "react-bootstrap/Form";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import {useTranslation} from "react-i18next";
import {forEach} from "react-bootstrap/cjs/ElementChildren";

export function UploadPdfResult(props) {
  const {t} = useTranslation();
  const sample_ids_textarea = useRef();
  const sample_id = useRef();
  const [patients, setPatients] = useState([]);
  const [patient, setPatient] = useState(null);
  const [show, setShow] = useState(false);
  const [action, setAction] = useState('patient');
  const [checkedItems, setCheckedItems] = useState({});
  const [barcodeFile, setBarcodeFile] = useState('');

  const [disabled, setDisabled] = useState(0);
  const [iconDisabled, setIconDisabled] = useState(1);

  const sample_id_param = props.match.params.sample_id;

  const history = useHistory()

  const setCurrentPatient = (patient, action) => {
    setPatient(patient);
    setAction(action);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  const handleSavePdfResult = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('result_pdf', barcodeFile);
    formData.append('sample_id', sample_id.current.value);
    setDisabled(true);
    axios.post(API_URL + "patient/save-pdf-report",
      formData, {
        'content-type': 'multipart/form-data'
      }).then((response) => {
        setDisabled(false);
      if (response.data.status) {
        alertify.success("Reports Saved Successfully");
      } else {
        alertify.error(response.data.message);
        return null;
      }
    }).catch((error) => {
      if (error.message === 'Request failed with status code 401') {
      }
    });
  }

  const handleResultPdf = (e) => {
    setBarcodeFile(e.target.files[0]);
  }

  return (
    <>
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader title={t("Upload Pdf Result")}>
              <CardHeaderToolbar></CardHeaderToolbar>
            </CardHeader>
            <CardBody style={{overflow: 'auto'}}>
              <Form onSubmit={handleSavePdfResult}>
                <Form.Row>
                  <Form.Group as={Col}>
                    <Form.Label>{t("Sample ID")}</Form.Label>
                    <Form.Control ref={sample_id} defaultValue={sample_id_param} placeholder={t("Sample ID")}/>
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label>{t("Choose PDF")}</Form.Label>
                    <Form.Control type={"file"} onChange={handleResultPdf}/>
                  </Form.Group>
                </Form.Row>
                <Button variant="primary" className="float-right" type="submit"
                        disabled={disabled}>
                  {t("Save")}
                  <span
                    dangerouslySetInnerHTML={{__html: disabled ? `<i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                </Button>

              </Form>
            </CardBody>
          </Card>

        </Col>
      </Row>
    </>
  )
}

